import { contactListKeys } from '@/queries/contacts/queryKeys';
import { queryContacts } from '@/queries/contacts/list';
import { useQuery, keepPreviousData } from '@/lib/tanstackQuery';
import { computed } from 'vue';

/**
 * @param {import('vue').Ref<string>} searchQuery
 */
export function useContactSearch(searchQuery) {
  const queryKey = computed(() =>
    (searchQuery.value ? contactListKeys.search(searchQuery.value) : contactListKeys.all));

  const query = useQuery({
    queryKey,
    queryFn: queryContacts,
    placeholderData: keepPreviousData,
  });

  return {
    contacts: query.data,
    refetchContacts: query.refetch,
  };
}
